import Copy from './Copy/Copy';
import Delete from './Delete/Delete';
import Create from './Create/Create' 
import Move from './Move/Move';
import Rename from './Rename/Rename';
import { types } from './types';

//Enter the switch according to the incoming action names, it renders.
function Actions(action, showAlert, variables, setOpenVariable, variableRender) {
    switch (action.actionName) {
        case types.COPY: return <Copy action={action}  showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>;
        case types.DELETE: return <Delete action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>;
        case types.CREATE: return <Create action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>;
        case types.MOVE: return <Move action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>;
        case types.RENAME: return <Rename action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>;
        default: break;
    }
}
export default Actions;